import React, { useState, ChangeEvent } from 'react';
import './SliderSwitch.css'; // Ensure this file includes the necessary CSS

interface SliderSwitchProps {
  name: string;
  defaultChecked?: boolean;
  onChange?: (name: string, value: boolean) => void;
  dataBsToggle?: string;
  dataBsTarget?: string;
}

const SliderSwitch: React.FC<SliderSwitchProps> = ({
  name,
  defaultChecked = false,
  onChange,
  dataBsToggle,
  dataBsTarget
}) => {


  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;

    if (onChange) {
      onChange(name, checked);
    }
  };

  return (
    <label className="switch">
      <input
        type="checkbox"
        name={name}
        checked={defaultChecked}
        onChange={handleChange}
        data-bs-toggle={dataBsToggle}
        data-bs-target={dataBsTarget}
      />
      <span className="slider"></span>
    </label>
  );
};

export default SliderSwitch;
